import { Checkbox } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import React, { useEffect } from 'react';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';

export interface CheckboxGroupProps {
  width?: string;
  items: { id: string; name: string; checked: boolean }[];
  setItems: any;
}

const CheckboxGroup: React.FC<CheckboxGroupProps> = ({
  width,
  items,
  setItems,
}) => {
  const useStyles = makeStyles()({
    root: {
      display: 'flex',
      flexDirection: 'column',
    },
    checkbox: {
      '&.MuiCheckbox-root': {
        padding: '0px',
      },

      '&:hover': {
        backgroundColor: 'transparent !important',
      },
      '& .MuiSvgIcon-root': {
        width: '24px',
        height: '24px',
      },
    },
    firstItem: {
      display: 'flex',
      background: '#EEF3FF',
      padding: '7px 20px 8px 15px',
      borderRadius: '4px',
      width: width ?? 'fit-content',
    },
    restItems: {
      display: 'flex',
      padding: '0px 0px 0px 15px',
      margin: '-3px 0px -3px 0px',
    },
  });

  const handleChange = (event: any, index: number) => {
    setItems(
      items?.map((item: any) => {
        if (index === 0) {
          return { ...item, checked: event?.target.checked };
        } else {
          if (item?.name === event.target.name) {
            return { ...item, checked: event?.target.checked };
          } else {
            return item;
          }
        }
      }),
    );
  };

  const handleSelectAll = () => {
    let checkedCount = 0;
    items?.map((item: any, index: number) => {
      if (index !== 0 && item.checked === true) {
        checkedCount++;
      }
    });
    if (checkedCount === items?.length - 1) {
      items[0].checked = true;
    } else {
      items[0].checked = false;
    }
  };

  useEffect(() => {
    handleSelectAll();
    setItems(items);
  }, [items]);

  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      {items?.map((item: any, index: number) => {
        return (
          <div key={index}>
            <div
              className={index === 0 ? classes.firstItem : classes.restItems}
            >
              <Checkbox
                className={classes.checkbox}
                color="primary"
                name={item?.name}
                onChange={(event: any) => handleChange(event, index)}
                checked={items[index]?.checked}
                disableRipple={true}
                icon={
                  <CheckBoxOutlineBlankOutlinedIcon
                    style={{
                      color: patientAccessTheme.palette.checkbox?.border1,
                    }}
                  />
                }
              />
              <Typography
                textColor={patientAccessTheme.palette.text.highemphasis}
                fontSize="14px"
                lineHeight="24px"
                fontType={index === 0 ? 'semiBold' : 'regular'}
                margin="0px 0px 0px 12px"
              >
                {item?.name}
              </Typography>
            </div>
            {index < items?.length - 1 && (
              <div
                style={{
                  background: patientAccessTheme.palette.grey[300],
                  width: '1px',
                  marginLeft: '26px',
                  height: index === 0 ? '26px' : '24px',
                }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default CheckboxGroup;
